import comment from 'iz-ds-neo-alt/dist/system/i18n/vi/comment'

export default {
  ...comment,
  MSG_COMMENT_SUCCESS: 'Hệ thống đã nhận được bình luận của bạn!',
	MSG_COMMENT_SUCCESS_AND_WAIT_APPROVAL: 'Hệ thống đã nhận được bình luận của bạn. Vui lòng chờ admin kiểm duyệt!',
	MSG_COMMENT_FAIL: 'Hệ thống không nhận được bình luận của bạn. Vui lòng thử lại sau.',
	MSG_COMMENT_LOADING: 'Hệ thống đang nhận bình luận của bạn. Vui lòng chờ trong giây lát!',
}